import React from 'react';
import ReactDOM from 'react-dom';
import { unregister } from './registerServiceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import ReduxPromise from 'redux-promise';
import ReduxThunk from 'redux-thunk';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import App from './components/App/App';
import Signin from './components/Auth/Signin';
import AuthRedirect from './HOC/AuthRedirect';
import RequireAuth from './HOC/RequireAuth';
import Dashboard from './containers/Dashboard/Dashboard';
import Stats from './containers/Stats/Stats';
import TradeHistory from './containers/TradeHistory/TradeHistory';
import Signup from './components/Auth/Signup';
import Signout from './components/Auth/Signout';

import { UPDATE_FONT_SIZE } from './actions/types';
import { setUp } from './actions';
import Socket from './middlewares/socket';

import 'normalize.css'; 
import './contextmenu.css';
import './index.css';
import './loading.css';
import './dropdown.css';

import reducers from './reducers';

console.log(`Running on ${process.env.REACT_APP_ENV} environment.`);

unregister();

const createStoreWithMiddleware = applyMiddleware(ReduxPromise, ReduxThunk, Socket)(createStore);
const store = createStoreWithMiddleware(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const token = localStorage.getItem('token');
const currentUser = localStorage.getItem('currentUser');
if (token) {
  store.dispatch(setUp({ email: currentUser }))
}

const fontSize = localStorage.getItem('fontSize');
if (fontSize) {
  store.dispatch({ type: UPDATE_FONT_SIZE, payload: +fontSize });
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <App>
          <Route path="/stats" component={RequireAuth(Stats)} />    
          <Route path="/tradehistory" component={RequireAuth(TradeHistory)} />      
          <Route path="/dashboard" component={RequireAuth(Dashboard)} />
          <Route path="/signup" component={AuthRedirect(Signup)} />
          <Route path="/signin" component={AuthRedirect(Signin)} />
          <Route path="/signout" component={Signout} />
          <Route exact path="/" render={() => (
            token ? (
              <Redirect to="/dashboard"/>
            ) : (
              <Redirect to="/signin"/>
            ))} />
        </App>
      </Switch>
    </BrowserRouter>
  </Provider>
  , document.getElementById('root'));
